Popup = {
    isFixed: true,
    removeAfterHide: false,
    showAfterLoad: false,
    useCookie:false,
    el: {},

    init: function() {
        Popup.el = $('.popup');

        $('.popup .close').click(function(event) {
            Popup.hide();
        });

        $(document).on('click', function(e) {
            if (e.target != Popup.el.get(0) && !Popup.el.find(e.target).length) {
                Popup.hide();
                $(this).off(e);
            }
        });

        if(this.showAfterLoad){
            this.afterPageLoaded();
        }

        $('.popup').find('a').on('click', function(event) {
            Popup.setCookie();
        });

    },

    afterPageLoaded: function(){
        setTimeout(function() {
            // console.log(Popup.getCookie() && $('.popup .locator .item').length != 0)
            if (Popup.getCookie() && $('.popup .locator .item').length != 0 && $(window).innerWidth() >= 768)
                Popup.show();
        }, 200);
    },

    show: function() {
        Popup.el.addClass('visible');
        if(this.isFixed)
            Popup.el.addClass('fixed');

        Popup.el.find('.inner').css('margin-top', $('body').scrollTop() + 140 + 'px').addClass('show').removeClass('hide');
        Popup.el.find('.bg').addClass('show').removeClass('hide');;
    },

    hide: function() {
        Popup.el.find('.inner').addClass('hide');
        Popup.el.find('.bg').addClass('hide');
        Popup.el.find('.bg').on('oanimationend animationend webkitAnimationEnd oAnimationEnd oAnimationEnd ', function() {
            if(Popup.removeAfterHide)
                Popup.el.remove()
        });

        if(this.useCookie)
            Popup.setCookie();
    },

    setCookie: function() {
        var date = new Date();
        var minutes = 360;
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        Cookies.set('closedPopup', 1, { expires: date });
    },

    getCookie: function() {
        if (Cookies.get('closedPopup'))
            return false;

        return true;
    }
}